<template>
  <div class="head">
    <i v-if="flag"></i>
    <em></em>
    <p>{{ name }}</p>
    <div class="unit" v-if="unit">｜ 万吨</div>
    <img v-if="neibu" src="../../assets/home/neibu.png" style="width: 70px;margin-left: 10px;vertical-align: middle" alt="">
    <span class="fr" @click="toTwoPage">更多 ></span>
  </div>
</template>

<script>
export default {
  name: "home-header",
  props: ['name', 'flag', 'unit', 'params', 'url', 'neibu'],
  methods: {
    /**
     * 跳转二级页
     */
    toTwoPage() {
      this.$router.push({path: `${this.url}`,});
    },
  }
}
</script>

<style scoped lang="less">

.head {
  color: #222222;
  height: 35px;
  line-height: 30px;
  position: relative;
  border-bottom: 2px solid #ccc;

  i {
    width: 60px;
    height: 2px;
    background: #CCCCCC;
    display: inline-block;
    position: absolute;
    bottom: 0;
  }

  em {
    width: 4px;
    height: 18px;
    background: #D3131A;
    font-style: normal;
    display: inline-block;
    margin-right: 9px;
    vertical-align: middle;
  }

  p {
    font-size: 18px;
    display: inline-block;
    vertical-align: middle;
  }

  .unit {
    color: #999999;
    margin-left: 10px;
    display: inline-block;
    font-size: 14px;
  }

  span {
    font-size: 12px;
    cursor: pointer;
    height: 20px;
    border-bottom: 1px solid #fff;
  }

  span:hover {
    border-bottom: 1px solid #222;
  }
}
</style>
